import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { resetUpdateUserAccount, updateUserAccount } from "./update-user-account";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateUserAccountReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateUserAccount.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(updateUserAccount.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateUserAccount.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateUserAccount, () => {
    return initialState;
  });
});
